<div>
    <b>Entry #: {{entry.submissionID}}</b>
</div>
<div style="background-color: #EEE; border-radius: .25rem; border-width: 1px; border-style: solid;">
    <div class="container">
        <div class="row">
            <app-showimg class="col" [entryImage]='entry.entryImage1'></app-showimg>
            <app-select-entry class="col-auto align-self-center" 
                (selectEntry)='bubbleEntry($event)' 
                [entry]='entry'>
            </app-select-entry>
            <app-showimg class="col" [entryImage]='entry.entryImage2'></app-showimg>
        </div>
    </div>
</div>
